// build-info.js — Version und Build-Zeitpunkt, beim Vite-Build eingesetzt (vite.config.js → define).
// Die Version stammt aus CACHE_NAME in public/sw.js; ohne Build (Node-Tests) sind beide null.
/* global __VC_VERSION__, __VC_BUILD_TIME__ */
export const VERSION = typeof __VC_VERSION__ !== 'undefined' ? __VC_VERSION__ : null;
export const BUILD_TIME = typeof __VC_BUILD_TIME__ !== 'undefined' ? __VC_BUILD_TIME__ : null;
